import { render, staticRenderFns } from "./PicTextView.vue?vue&type=template&id=987749ba&scoped=true"
import script from "./PicTextView.vue?vue&type=script&lang=js"
export * from "./PicTextView.vue?vue&type=script&lang=js"
import style0 from "./PicTextView.vue?vue&type=style&index=0&id=987749ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987749ba",
  null
  
)

export default component.exports